<template>
  <app-header></app-header>
  <section class="wrapper gift-shop">
    <nav-aside v-show="!isMobile"></nav-aside>
    <router-view></router-view>
  </section>
  <app-footer></app-footer>
  <Loading v-show="loading"></Loading>
</template>

<script>
import NavAside from '@/pages/GiftShop/GiftShopNav.vue';
import AppHeader from '@/components/Header.vue';
import AppFooter from '@/components/Footer.vue';
import Loading from '@/components/Loading.vue';

export default {
  name: 'GiftItem',
  components: {
    'app-header': AppHeader,
    'app-footer': AppFooter,
    'nav-aside': NavAside,
    Loading,
  },
  props: {},
  setup() {
    return {};
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  async mounted() {},
  methods: {},
};
</script>

<style lang="scss">
@import '@/assets/styles/pages/giftShop/giftShop.scss';
</style>
